// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__XcgSw","head":"Table_head__ZpXYe","col":"Table_col__A8F91"};